import React, { useEffect } from 'react'
import SearchableDropdown from '../common/SearchableDropdown'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getAllSchoolsAdmin } from '../../requests'
import { useDispatch } from 'react-redux'
import { startLoader, stopLoader } from '../../_store/reducers/loaderReducer'
import { deleteAuthToken, notifyError } from '../../utils/helper'
import { formatDateLong } from '../helper/formatters'
import AddSchool from '../Modals/AddSchool'


const Index = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [schoolCode, setSchoolCode] = useState("")
  const [schoolCodes, setSchoolCodes] = useState([
  ])

  const [schools, setSchools] = useState([])
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(5)
  const [totalCount, setTotalCount] = useState(0)
  const [showAddSchoolModal, setShowAddSchoolModal] = useState(false)
  const [type, setType] = useState('add')
  const [schoolData, setSchoolData] = useState(null)
  const [refresh, setRefresh] = useState(false)

  
  const getAllSchools = async (pageVal) =>{
    dispatch(startLoader())

    try {
      const response = await getAllSchoolsAdmin({page: pageVal, limit: limit, school_code: schoolCode == "All" ? "" : schoolCode.trim()});
      if(response.status == 200){
        setSchools(response.data.data);
        setSchoolCodes(["All", ...response.data.school_codes])
        setTotalCount(response.data.totalCount);
      }
     

    } catch (error) {
      if(error?.response?.status == 403){
        notifyError(error?.response?.data?.error ||"Your session has expired. Please log in again.")
        deleteAuthToken()
        navigate('/login')
        return;
      }
      notifyError(error?.response?.data?.error || "Something went wrong");
    } finally {
      dispatch(stopLoader())
    }
  }


  const handleViewSchool = (e) => {
    navigate(`/school-management/teachers`,{state:{school_code: e.school_code, school_name: e.school_name, school_id: e.id}})
  }

  const handleEditSchool = (e) => {
    setType('edit')
    setSchoolData(e)
    setShowAddSchoolModal(true)
  }

  const handleAddSchool = () => {
    setType('add')
    setSchoolData(null)
    setShowAddSchoolModal(true)
  }

  useEffect(() => {
    setPage(1)
    getAllSchools(1)
  }, [schoolCode, refresh])

  useEffect(() => {
    getAllSchools(page)
  }, [page, limit])
  
 
  return (
    <div className='tm-main'>

<div className="overview-head">
        <div className="overview-head-left">School management</div>
        {showAddSchoolModal && <AddSchool onClose={() => setShowAddSchoolModal(false)} type={type} data={schoolData} onRefresh={() => setRefresh(!refresh)} />}
        <div className="overview-head-right">
          <button className="my-btn" onClick={handleAddSchool}>Add School</button>
          <SearchableDropdown
            options={[...schoolCodes]}
            selected={schoolCode}
            setSelected={(e) => setSchoolCode(e)}
            color="#E5E7EB"
            placeHolder='Enter school code'
          />
          
        </div>
      </div>

      <div className="ai-fd-table">
        <div className="ai-fd-table-head">
          <div className="ai-fd-head-cell" style={{ width: "20%" }}>
            School Name
          </div>
          <div className="ai-fd-head-cell" style={{ width: "15%" }}>
            School Code
          </div>
          <div className="ai-fd-head-cell" style={{ width: "20%" }}>
            Location
          </div>
          <div className="ai-fd-head-cell" style={{ width: "10%" }}>
            Total evaluations
          </div>

          <div className="ai-fd-head-cell" style={{ width: "15%" }}>
           Updated on
          </div>
          <div className="ai-fd-head-cell" style={{ width: "20%" }}>Action</div>
         
        </div>
        {schools.length > 0 &&
          schools.map((e, i) => (
            <div key={i} className="ai-fd-table-row">
              <div className="ai-fd-row-cell" style={{ width: "20%" }}>
                {e.school_name}
              </div>
              <div className="ai-fd-row-cell" style={{ width: "15%" }}>
                {e.school_code}
              </div>
              <div className="ai-fd-row-cell" style={{ width: "20%" }}>
                {e.location}
              </div>
              <div className="ai-fd-row-cell" style={{ width: "10%" }}>
                {e.total_papers}
              </div>
              <div className="ai-fd-row-cell" style={{ width: "15%" }}>
                {formatDateLong(e.updated_at)}
              </div>
              <div className="ai-fd-row-cell" style={{ width: "20%", display: "flex", gap: "10px" }} >
                <button className="my-btn" style={{ backgroundColor: "#E0F5FE", color: "#01A7DE" }} onClick={() => handleViewSchool(e)}>View</button>
                <button className="my-btn" style={{ backgroundColor: "#E0F5FE", color: "#01A7DE" }} onClick={() => handleEditSchool(e)}>Edit</button>
              </div>
              
            </div>
          ))}
      </div>
      <div className="di-flex" style = {{width: '100%'}}>
          <div style={{ color: "#6B7280" }}>
            {" "}
            Showing {((page-1) * limit )+ 1} to {schools.length + (page - 1) * limit} out of {totalCount}{" "}
            items{" "}
          </div>
          <div
            className="di-flex"
            style={{ justifyContent: "end", gap: "10px" }}
          >
            <button
              disabled={page == 1}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity: page == 1 ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (p > 1 ? p - 1 : p))}
            >
              Previous
            </button>
            <button
              disabled={schools.length + (page - 1) * limit >= totalCount}
              className="my-btn"
              style={{
                backgroundColor: "#E0F5FE",
                color: "#01A7DE",
                opacity:
                  schools.length + (page - 1) * limit >= totalCount ? 0.4 : 1,
              }}
              onClick={() => setPage((p) => (schools.length ? p + 1 : p))}
            >
              Next
            </button>
          </div>
        </div>


      
      </div>

    
  )
}

export default Index